import React, { useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { UploadCloud, Trash2 } from "lucide-react";
import ImageWithBaseApi from "components/common/mediaRender/ImageWithBaseApi";

const SortableItem = ({ image, onRemove, onDelete }) => (
  <div className="gallery-image relative">
    {image.src ? (
      <ImageWithBaseApi src={image.preview} className="object-cover rounded-md shadow" />
    ) : (
      <img src={image.preview || image.src} alt="preview" className="object-cover rounded-md shadow" />
    )}
    <button
      onClick={async (e) => {
        e.stopPropagation();
        if (image.id) {
          try {
            await onDelete(image.id);
            onRemove(image);
          } catch (error) {
            alert("Algo salió mal al intentar eliminar esta imagen.");
          }
        } else {
          onRemove(image);
        }
      }}
      className="absolute top-1 right-1 bg-red-600 text-white p-1 rounded-full"
    >
      <Trash2 size={14} />
    </button>
  </div>
);

const ImageGallery = ({ initialImages = [], onImagesChange, onDeleteImage }) => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const formattedImages = initialImages.map((image) => {
      if (image.file) {
        return image;
      } else {
        return {
          file: { path: image.src },
          preview: image.src,
          src: image.src,
          id: image.id,
        };
      }
    });
    setImages(formattedImages);
  }, [initialImages]);

  const onDrop = (acceptedFiles) => {
    const newImages = acceptedFiles.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    const updatedImages = [...images, ...newImages];
    setImages(updatedImages);
    onImagesChange(updatedImages);
  };

  const removeImage = (image) => {
    const updatedImages = images.filter((img) => img !== image);
    setImages(updatedImages);
    onImagesChange(updatedImages);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: "image/*",
    multiple: true,
  });

  return (
    <div {...getRootProps()} className={`border-2 border-dashed p-4 rounded-lg cursor-pointer relative gallery-upload ${isDragActive ? 'is-dragging' : ''}`}>
      <input {...getInputProps()} className="absolute inset-0 opacity-0 cursor-pointer" />
      <div className="flex flex-col items-center justify-center text-center text-gray-500">
        {isDragActive ? (
          <p>Suelta aquí</p>
        ) : (
          <>
            <p>Arrastra y suelta imágenes aquí o haz clic para seleccionar</p>
          </>
        )}
      </div>
      <div className="d-flex flex-wrap mt-4 gallery-images">
        {images.length === 0 ? (
          <div className="w-full text-center text-gray-500 w-auto d-flex flex-column justify-content-center m-auto align-items-center">
            <UploadCloud size={48} className="mb-2" />
            <p>Sube tus imagenes a la galeria</p>
          </div>
        ) : (
          images.map((image, index) => (
            <SortableItem key={image.file.path || image.preview} index={index} image={image} onRemove={removeImage} onDelete={onDeleteImage} />
          ))
        )}
      </div>
    </div>
  );
};

export default ImageGallery;